import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-date-picker";
import { Controller } from "react-hook-form";
import styles from "./DatePicker.module.scss";

function DatePickerComponent({
  control,
  name,
  isRequired,
  errors,
  className,
  classNamedark,
  maxDate,
  label,
}) {
  // console.log(name,"name date");
  let classNamess = className;

  if (localStorage.getItem("theme") === "dark") {
    classNamess = classNamedark;
  }

  const convertToUTC = (date) => {
    if (!date) return null;
    return new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
  };

  const isMonday = (date) => {
    return date.getDay() === 1; // 0 for Sunday, 1 for Monday, and so on
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={{
          required: {
            value: isRequired,
            message: `${label} is required`,
          },
        }}
        render={({ field }) => (
          <div>
            <DatePicker
              className={classNamess ?? className}
              id={styles.datepicker}
              onChange={(date) => {
                console.log(date, "dateggg ");
                const utcDate = convertToUTC(date);
                console.log("utc time ", utcDate);
                field.onChange(utcDate);
              }}
              value={
                typeof field.value === "string"
                  ? new Date(new Date(field.value))
                  : field.value
              }
              format="dd/MM/y"
              // tileDisabled={({ date }) => !isMonday(date)} // Disable non-Mondays
              // minDate={new Date()}
            />
            {/* {console.log(field.value,"field.value")} */}
          </div>
        )}
      />
      <p
        style={{
          color: "red",
          marginTop: "5px",
          fontSize: "14px",
          fontFamily: "SFUIDisplayRegular",
        }}
      >
        {" "}
        {
          // Shows if error exist
          errors[name] && errors[name].message
        }{" "}
      </p>
    </>
  );
}

DatePickerComponent.propTypes = {
  control: PropTypes.oneOfType([PropTypes.object]).isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  errors: PropTypes.PropTypes.oneOfType([PropTypes.object]).isRequired,
  className: PropTypes.string,
  classNamedark: PropTypes.string,
  label: PropTypes.string,
  maxDate: PropTypes.any,
};
DatePickerComponent.defaultProps = {
  isRequired: false,
  classNamedark: null,
  className: "default-input-class",
  maxDate: new Date(),
  label: "Date",
};

export default DatePickerComponent;
